import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const GridColCardContainer = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
`;

export const GridColCardHeader = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${colors.textExGrayLight};
  padding: 15px;
`;

export const GridColCardBody = styled.div`
  padding: 8px 15px;
`;

export const GridColCardFooter = styled.div`
  border-top: 1px solid ${colors.textExGrayLight};
  display: flex;
  flex-direction: column;
  padding: 8px 15px;
`;

export const GridColCardHeaderIcon = styled.div`
  width: 35px;
  height: 35px;
  background: ${colors.bgTertiary};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
`;

export const GridColCardHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-size: 12px;
  }
`;

export const GridColCardBodyGrid = styled.div`
  display: flex;
  justify-content: space-between;

  & + & {
    margin: 8px 0;
  }
`;

export const GridColCardBodyLabel = styled.span`
  color: ${colors.textSecondary};
  font-size: 12px;
  line-height: 23px;
`;

export const GridColCardBodyValue = styled.span`
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 23px;
  text-align: right;
`;

export const GridColCardFooterPrice = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GridColCardFooterLabel = styled.span`
  color: ${colors.textPrimary};
  font-size: 10px;
  line-height: 23px;
`;

export const GridColCardFooterValue = styled.span`
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-top: 10px;
`;

export const GridColCardFooterValueInfo = styled.span`
  font-size: 14px;
  color: ${colors.textPrimary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GridColCardFooterButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.textSecondary};
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 12px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
  -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const GridColCardFooterStatus = styled.div`
  width: 100%;
  height: 25px;
  background: ${prop => prop.background};
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
`;

export const AnularFooterButton = styled.span`
  text-decoration: underline;
  color: ${colors.textHyperlink};
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;

  &:hover {
    color: ${colors.bgSecondaryHover};
  }
`;
